package dev.lingvo.shared

import kotlinx.serialization.Serializable

/** Remote metadata may be incomplete without making a readable set disappear. */
@Serializable
data class StoreShotImageDto(
    val position: Int, val width: Int? = null, val height: Int? = null,
    val sha256: String? = null, val previewUrl: String? = null,
)

/** Unreadable locales remain visible with their failure explanation. */
@Serializable
data class StoreShotSetDto(
    val locale: String, val storeLocale: String, val deviceClass: DeviceClass,
    val images: List<StoreShotImageDto>, val readable: Boolean = true, val note: String? = null,
)

/** Read results preserve version state independently of available image sets. */
@Serializable
data class StoreShotsDto(
    val platform: StorePlatform, val editable: Boolean, val stateNote: String? = null, val sets: List<StoreShotSetDto>,
)

/** Import scope is explicit and creating plan slots requires a deliberate choice. */
@Serializable
data class ShotStoreImportRequest(
    val locales: List<String>? = null, val devices: List<DeviceClass>? = null, val createSlots: Boolean = false,
)

/** Skipped images remain attributable to a store cell and position. */
@Serializable
data class ShotImportSkipDto(val locale: String, val deviceClass: DeviceClass, val position: Int, val reason: String)

/** Import results expose partial success and any new plan keys. */
@Serializable
data class ShotStoreImportDto(
    val imported: Int, val skipped: List<ShotImportSkipDto> = emptyList(), val createdSlots: List<String> = emptyList(),
)
